import 'jquery';
import 'jquery-ui/dist/jquery-ui';


import './theme/lead/fonts/bootstrap/bootstrap-icons.css';
import './theme/lead/vendor/overlay-scroll/OverlayScrollbars.min.css';
import './theme/lead/css/style.css';

// WYSIWYG
import 'summernote/dist/summernote-bs4.min.js';
import 'summernote/dist/summernote-bs4.min.css';

import './imgs/imgs';

import './controls/plan';
import './controls/acl';
import './controls/role';
import './controls/modal';
import './controls/flashes';
import './controls/columnOrder';
import './controls/invoiceFilter';
import './controls/fileUpload';
import './controls/baseGrid';
import './controls/fullCalendar';
import './controls/invoice';
import './controls/dependentSelect';
import './controls/IframeInput';
import './controls/wysiwyg';
import './controls/checkboxFilter';
import './controls/checkboxSelectAll';
import './controls/store'
import './controls/selectChange';
import './controls/userDevice';
import './controls/share';
import './controls/DeviceGraph';
import './controls/balance';
import './controls/elektrarnaDetail';
import './controls/aiChat';

import './ui/select2';
import './ui/naja';
import './ui/live-form-validation';
import './ui/bootstrap-datepicker';
import './ui/datagrid';
import './ui/slick';
import './ui/ares';
import './controls/forms';
import './controls/timeSheet';
import './controls/contentDropdown';

// import './ui/flashes';

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
import './theme/lead/js/bootstrap.bundle.min';
import './theme/lead/vendor/overlay-scroll/jquery.overlayScrollbars.min';
import './theme/lead/vendor/overlay-scroll/custom-scrollbar';
import './theme/lead/js/custom';

// Webpack HMR
if (module.hot) {
    module.hot.accept();
}
